export const LOG_COLLECTION = process.env.REACT_APP_LOGS_ENV;
export const ENABLE_LOGS = process.env.REACT_APP_LOGS_ENABLE === 'true';
